<aside class="xm-sidebar-content">
  <ng-template #defaultSidebarRef>
    <xm-logo></xm-logo>
    <mat-divider></mat-divider>

    <div class="section-scroll">
      <xm-sidebar-user [config]="config?.user"></xm-sidebar-user>
      <mat-divider></mat-divider>
      <xm-menu></xm-menu>
    </div>

    <div class="xm-sidebar-background"></div>
  </ng-template>

  <ng-container *ngIf="config?.layout; else defaultSidebarRef">
    <xm-dynamic-widget-layout class="xm-sidebar-content__dynamic-content" [layouts]="config.layout"></xm-dynamic-widget-layout>
  </ng-container>
</aside>
